import {Col, Form, Input, Modal, Row} from "antd";
import {useFormik} from "formik";
import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {useStore} from "../../../../../hooks/useStore";
import * as Sentry from "@sentry/react";

export const BillingUpdateModal = ({subCompany, visibility, onCancel}) => {
    const stores = useStore();
    const {t} = useTranslation(["subcompanyDetail"]);
    const [confirmLoading, setConfirmLoading] = useState(false);

    const formik = useFormik({
        initialValues: {
            ...subCompany
        },
        enableReinitialize: true,
        onSubmit: async vals => {
            const {subCompanyCode, cariCode, ...values} = vals;

            setConfirmLoading(true);

            try {
                await stores.companyStore.updateSubCompany(values);

                await onCancel(true);
            } catch (error) {
                Sentry.captureException(error);
            } finally {
                setConfirmLoading(false);
            }
        }
    });

    const {values, handleSubmit, handleChange, resetForm} = formik;

    useEffect(() => resetForm(), [visibility]);

    return (
        <Modal
            title={"Cari Bilgileri Düzenle"}
            visible={visibility}
            onCancel={() => {
                onCancel(false);
            }}
            onOk={handleSubmit}
            confirmLoading={confirmLoading}
            okText={t("modal.saveButton", {ns: "common"})}
            cancelText={t("modal.cancelButton2", {ns: "common"})}
        >
            <Form labelCol={{span: 24}} wrapperCol={{span: 24}}>
                <Row>
                    <Col span={24}>
                        <Form.Item>
                            <h4>Ticari Ünvan</h4>
                            <Input
                                name="bill.commercialTitle"
                                onChange={handleChange}
                                value={values?.bill?.commercialTitle}
                            />
                        </Form.Item>
                        <Form.Item>
                            <h4>Cari Kodu</h4>
                            <Input
                                disabled
                                name="cariCode"
                                onChange={handleChange}
                                value={values.cariCode}
                            />
                        </Form.Item>
                        <Form.Item>
                            <h4>Proje Kodu</h4>
                            <Input
                                disabled
                                name="projectCode"
                                onChange={handleChange}
                                value={values.projectCode}
                            />
                        </Form.Item>
                        <Form.Item>
                            <h4>Vergi Dairesi</h4>
                            <Input
                                name="bill.registeredTaxOffice"
                                onChange={handleChange}
                                value={values?.bill?.registeredTaxOffice}
                            />
                        </Form.Item>
                        <Form.Item>
                            <h4>Vergi Numarası</h4>
                            <Input
                                name="bill.taxNumber"
                                onChange={handleChange}
                                value={values?.bill?.taxNumber}
                            />
                        </Form.Item>
                        <Form.Item>
                            <h4>Fatura Adresi</h4>
                            <Input
                                name="bill.billInformation"
                                onChange={handleChange}
                                value={values?.bill?.billInformation}
                            />
                        </Form.Item>
                        <Form.Item>
                            <h4>Telefon Numarası</h4>
                            <Input
                                name="authorizedPhone"
                                onChange={handleChange}
                                value={values.authorizedPhone}
                            />
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Modal>
    );
};
